import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { IRessource } from '../models/ressource';
import { RessourceService } from '../services/ressource.service';

@Injectable({
  providedIn: 'root'
})
export class SchedulerResourcesResolver  {
  constructor(
    private ressourceService : RessourceService
  ){}

  resolve(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
    ): Observable<IRessource[]> {
    return this.ressourceService.searchRessources({pageNumber: 0, pageSize: 999999, isNotHidden: true})
    .pipe(
      map(response => response.data)
    )
  }
}
